import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "@/lib/auth";
import { ADMIN } from "@/constants/testIds";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await adminLogin(password);
      nav("/admin");
    } catch (err) {
      setError(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid={ADMIN.loginPage} className="min-h-screen bg-ink text-bone flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <p className="eyebrow text-fog mb-4">RELATABLE / Admin</p>
        <h1 className="font-display text-5xl md:text-6xl tracking-tighter font-medium leading-[0.95] mb-10">
          Studio Console.
        </h1>
        <form onSubmit={onSubmit} className="space-y-6 border border-line p-8">
          <div>
            <label className="eyebrow text-fog block mb-3">Admin password</label>
            <input
              data-testid={ADMIN.loginPasswordInput}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
              required
              className="w-full bg-transparent border-b border-line py-3 focus:border-relatable outline-none text-bone text-lg"
            />
          </div>
          {error && <p className="eyebrow text-red-400">{error}</p>}
          <button
            type="submit"
            data-testid={ADMIN.loginSubmit}
            disabled={loading}
            className="w-full px-6 py-4 bg-bone text-ink eyebrow hover:bg-relatable hover:text-bone transition-colors disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign In →"}
          </button>
        </form>
        <p className="mt-6 eyebrow text-fog text-center">Single admin password. Stored in env.</p>
      </div>
    </main>
  );
}
